<div class="shared-authority-modal">
  <p-dialog class="shared-authority-dialog" header="{{ 'EC1 #' + sharedAuthority?.ec1Number }}" [closeOnEscape]="false" [(visible)]="displaySharedModal"
    [modal]="true" [closable]="true" [focusOnShow]="false" [blockScroll]="true" [style.width]="600" [draggable]="false"
    (onHide)="closeAllModel()">
    <div class="landing-page-blocking" [hidden]="!blocked">
      <span>Loading...</span>
    </div>
    <div class="shared-authority-content" *ngIf="!showModification">
      <div class="shared-authority-title">
        <div class="shared-authority-heading">{{ '#' + sharedAuthority?.ec1Number }}</div>
        <div class="shared-authority-line">{{ text }}: {{ sharedby }}</div>
        <br />
      </div>
    </div>
    <authority-modification [isInitialAuthority]="false" [authorityHistoryChanges]="authorityHistoryChange"
      [authorityHistoryCommonChange]="authorityHistoryCommonChange" [ec1Number]="sharedAuthority?.ec1Number"
      [isAuthoritySharedModel]="true" *ngIf="showModification"></authority-modification>
    <div class="landing-page-table">
      <div class="atm-table-table">
        <create-table-header [columnNames]="columnNames"></create-table-header>
        <div class="table-body">
          <div class="table-row">
            <authority-row [authority]="sharedAuthority" [showActionButtons]="false" [actionTableVisible]="false">
            </authority-row>
          </div>
        </div>
      </div>
    </div>

    <div class="action-wrapper">
      <div class="action-button-group" *ngIf="isActionAllowed && !rejectModification">
        <button pButton class="rejectBtn" type="button" (click)="rejectSharedAuthority()"
          label="{{ rejectLabel }}"></button>
        <button pButton class="acceptBtn" type="button" (click)="acceptSharedRequest()"
          label="{{ acceptLabel }}"></button>
      </div>
      <div class="action-button-group" *ngIf="isActionAllowed && rejectModification">
        <button pButton class="p-button-outlined" type="button" (click)="closeAllModel()" label="Close"></button>
      </div>
      <div class="action-button-group" *ngIf="!isActionAllowed">
        <span class="no-action-text">No Response Required</span>
      </div>
    </div>
  </p-dialog>
</div>

<user-confirmation-dialog [authority]="authorityForUserConfirmation" [action]="affirmationAction"
  (userAccept)="acceptedAuthority($event)" (userCancel)="userCancelled()"></user-confirmation-dialog>

<confirmation-dialog [showConfirmation]="showConfirmation" (confirmationAccept)="confirmationAccepted($event)"
  (confirmationCancel)="confirmationCancelled()" [showReason]="false" [showRejectReason]="showRejectReason"
  [data]="confirmationDialogData"></confirmation-dialog>
